import React, { useState, useEffect } from "react";
import "./banner.css";
import { Link } from "react-router-dom";

import banner1 from "../assets/images/slider-1.jpg";
// import banner2 from "../assets/images/slider-2.jpg";
// import banner3 from "../assets/images/slider-1.jpg"; 

const slides = [
{
  id: 1,
  image: banner1,
  subtitle: "Get instant access to funds",
  title: "Quick • Safe • Simple"
},
  // {
  //   id: 2,
  //   image: banner2,
  //   subtitle: "Business Loan",
  //   title: "Grow Your Business with Ease",
  //   highlight: "₹5,00,000",
  //   desc: "Quick approvals, minimal documentation, and flexible repayment options designed to suit your business needs."
  // },
  // {
  //   id: 3,
  //   image: banner3,
  //   subtitle: "Education Loan",
  //   title: "Secure Your Future Today",
  //   highlight: "₹10,00,000",
  //   desc: "Affordable interest rates and fast processing so you can focus on achieving your dreams without financial stress."
  // }
];

const Banner = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="banner-section fade-in"
      style={{ backgroundImage: `url(${slides[current].image})` }}
    >
      <div className="banner-overlay"></div>
      <div className="banner-content">
        <h5 className="subtitle">{slides[current].subtitle}</h5>
        <h1 className="title">
          {slides[current].title} <br />
           <span className="highlight">{slides[current].highlight}</span>
        </h1>
        <p className="desc">{slides[current].desc}</p>
<Link to="/apply-now" className="banner-btn">Apply Now</Link>
      </div>

      <div className="banner-video">
        <video
          className="banner-video-element"
          src={require("../assets/images/pro-video.mp4")}
          autoPlay
          muted
          loop
          playsInline
        />
      </div>

      {/* <div className="nav-arrows">
        <button onClick={() => setCurrent((current - 1 + slides.length) % slides.length)}>
          &#10094;
        </button>
        <button onClick={() => setCurrent((current + 1) % slides.length)}>
          &#10095;
        </button>
      </div> */}
    </section>
  );
};

export default Banner;
